(function(){
    'use strict'

    angular
    .module('app.permisos')
    .controller('Permisos', Permisos);

    Permisos.$inject = ['$animationsSrv', '$routeParams', 'PermisosService', 'logger', '$location'];

    function Permisos($animationsSrv, $routeParams, PermisosService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.permisos = [];
        vm.title = 'Permisos';

        var grupoId = $routeParams.id ? $routeParams.id : 0;

        getAll();

        vm.goToGrupo = function(grupo){
            
            var path = '/editar-grupo/';

            if(grupo){
                $location.path(path + grupo.id);
            }
            else{
                $location.path(path);
            }
            
        };

        function getAll(){

            var promise = PermisosService.getAll(grupoId);

            promise
            .then(function(permisos){
                vm.permisos = permisos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los permisos.');
                        break;
                }
            });
        };

        vm.saveAll = function(){
            save();
        };

        function save(){

            var promise = PermisosService.save(grupoId, vm.permisos);
            
            promise
            .then(function(response){
                logger.success('Permisos guardados con éxito.');
            })
            .catch(function(error){
                logger.error('Hubo un error al actualizar los datos');
            });               
        };

    }
})();